import React from "react";
import { ArrowUpRight, ArrowDownRight, Loader2 } from "lucide-react";
import { fmtPct } from "@/lib/format";

const TickerCard = ({ q }) => {
  const isUp = q.change_pct >= 0;
  return (
    <div
      data-testid={`market-card-${q.symbol}`}
      className="shrink-0 mx-3 min-w-[200px] px-5 py-3 rounded-2xl bg-white/70 backdrop-blur border border-[#E5E2DC] flex items-center gap-4"
    >
      <div className="flex flex-col">
        <span className="text-[10px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold">
          {q.name}
        </span>
        <span className="font-display text-lg text-[#1C2B23] font-mono-num">
          ${q.price.toLocaleString()}
        </span>
      </div>
      <div
        className={`flex items-center gap-1 text-sm font-mono-num ${
          isUp ? "text-[#348C59]" : "text-[#C26747]"
        }`}
      >
        {isUp ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />}
        {fmtPct(q.change_pct)}
      </div>
    </div>
  );
};

export default function MarketTicker({ snapshot, loading }) {
  if (loading) {
    return (
      <div data-testid="market-ticker-loading" className="py-4 flex items-center justify-center text-sm text-[#5C6B62] gap-2">
        <Loader2 className="animate-spin" size={14} /> loading live market data…
      </div>
    );
  }
  const quotes = snapshot?.quotes ?? [];
  if (!quotes.length) {
    return (
      <div data-testid="market-ticker-empty" className="py-4 text-sm text-center text-[#C26747]">
        Live market feed unavailable. Calculations use long-run historical priors.
      </div>
    );
  }
  // duplicate to make seamless scrolling loop
  const looped = [...quotes, ...quotes];
  return (
    <div data-testid="market-ticker" className="relative overflow-hidden border-y border-[#E5E2DC] bg-[#F0EFEA]/40 py-3">
      <div className="ticker-track flex w-max">
        {looped.map((q, i) => (
          <TickerCard key={`${q.symbol}-${i}`} q={q} />
        ))}
      </div>
    </div>
  );
}
